import tooltipImg from 'img/tooltip/edit-documents-in-attaches-toolip-img.png';
import React from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './EditDocumentCopyTooltip.css';

export interface EditDocumentCopyTooltipProps {
    target: Element | React.RefObject<HTMLElement> | null;
    onClick?: () => void;
    onClose?: () => void;
    onCrossClose?: () => void;
}

export function EditDocumentCopyTooltip({ target, onClick, onClose, onCrossClose }: EditDocumentCopyTooltipProps) {
    return (
        <FloatingTooltip
            target={target}
            placement={ETooltipPlacement.bottomEnd}
            size={ETooltipSize.fit}
            onClose={onClose}
            onCrossClose={onCrossClose}
            appearance={ETooltipAppearance.dark}
        >
            <div className={styles.root}>
                <div className={styles.textBlock}>
                    <div className={styles.title}>Редактирование теперь здесь</div>
                    <div className={styles.text}>Исправляйте текст, добавляйте комментарии и пометки</div>
                </div>
                <Button onClick={onClick} className={styles.button} theme="octavius" secondary={true} sizeMode={ButtonSizeMode.small}>
                    Попробовать
                </Button>
                <img className={styles.image} src={tooltipImg} alt="Картинка в тултипе" />
            </div>
        </FloatingTooltip>
    );
}
